import API from "../../helpers/network/http";

export default class TransactionService {
    // Create a method to fetch transactions
    static async fetchUserTransactions(): Promise<any> {

        // Call the login endpoint from the API
        const {data} = await API.get(`/transactions`);
        // Return the response
        return data;

    };

    // Create a method to fetch user transactions
    static async fetchUserTransaction(id: string): Promise<any> {

        // Call the login endpoint from the API
        const {data} = await API.get(`/transactions/${id}`, );

        // Return the response

        return data;

    }

}